import React, { useState } from 'react';
import Section from './Section';
import CriteriaBrief from '../../components/criteria/CriteriaBrief';
import { SAMPLE_CHIPS_WITH_NOTES, SAMPLE_CRITERIA_CHIPS, SAMPLE_NOTE_CHIPS } from './criteriaBriefFixtures';

/**
 * /design?only=criteria-brief — "Sourcing with these in mind": the buyer's
 * step-2 criteria shown back on the Smart BOM surfaces. Neutral chips are
 * saved answers (`ReadOnlyChip`); Robbie-tone chips are his reading of the
 * notes (`Badge tone="robbie" chip`), quoting the note on hover. While those
 * are pending or unavailable, the notes themselves show as one truncated
 * neutral chip ("Your notes"). Empty fields have no chip, and with no chips
 * at all the brief renders nothing.
 */
const Caption: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="m-0 mb-s2 text-meta text-ink-muted">{children}</p>
);

const CriteriaBriefGallery: React.FC = () => {
  const [asked, setAsked] = useState(false);
  const onAskRobbie = () => setAsked(true);

  return (
    <Section title="Criteria brief (Smart BOM, checkpoint, reveal card)">
      <div className="flex flex-col gap-s6">
        <div>
          <Caption>full · card — notes read (hover a violet chip for the quote)</Caption>
          <CriteriaBrief chips={SAMPLE_CRITERIA_CHIPS} noteChips={SAMPLE_NOTE_CHIPS} onAskRobbie={onAskRobbie} />
        </div>
        <div>
          <Caption>full · strip — the Smart BOM sheet’s footer band</Caption>
          <div className="overflow-hidden rounded-card border border-line">
            <div className="h-s7 bg-surface" />
            <CriteriaBrief chips={SAMPLE_CRITERIA_CHIPS} noteChips={SAMPLE_NOTE_CHIPS} surface="strip" onAskRobbie={onAskRobbie} />
          </div>
        </div>
        <div>
          <Caption>compact — first four, the rest behind “+N” (hover it)</Caption>
          <CriteriaBrief chips={SAMPLE_CRITERIA_CHIPS} noteChips={SAMPLE_NOTE_CHIPS} variant="compact" onAskRobbie={onAskRobbie} />
        </div>
        <div>
          <Caption>pointers pending or unavailable — the notes as written, one line (hover for all of it)</Caption>
          <CriteriaBrief chips={SAMPLE_CHIPS_WITH_NOTES} noteChips={[]} onAskRobbie={onAskRobbie} />
        </div>
        <div>
          <Caption>compact, notes standing in — they fold into “+N” like any other chip</Caption>
          <CriteriaBrief chips={SAMPLE_CHIPS_WITH_NOTES} noteChips={[]} variant="compact" onAskRobbie={onAskRobbie} />
        </div>
        <div>
          <Caption>structured only — no notes at all; viewers get no link</Caption>
          <CriteriaBrief chips={SAMPLE_CRITERIA_CHIPS} noteChips={[]} />
        </div>
        <p className="m-0 text-meta text-ink-muted">
          {asked
            ? '“Ask Robbie to change” sends “I’d like to change my sourcing criteria” into the wizard chat. (gallery stub)'
            : 'Nothing set at all → nothing rendered.'}
        </p>
      </div>
    </Section>
  );
};

export default CriteriaBriefGallery;
